import { httpClient } from './httpClient';
import mockCalendar from '../utils/date/mock-calendar.json';

export interface CalendarConfig {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: WeekData[];
}

export interface WeekData {
  sequence: number;
  weeklySequence: number;
  startDate: string;
  endDate: string;
}

export interface SystemSettingConfig {
  id: string;
  key: string;
  value: string;
}

/**
 * 获取日历配置信息
 * @returns 日历配置数据
 */
export async function getCalendarConfig(): Promise<CalendarConfig> {
  try {
    // 首先尝试从API获取日历配置
    const accessToken = localStorage.getItem('accessToken');
    
    const response = await httpClient.sendRequest({
      url: 'config/calendar',
      method: 'GET',
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    
    return response.data;
  } catch (error) {
    return mockCalendar as CalendarConfig;
  }
} 

export async function getSystemSettingConfig(): Promise<SystemSettingConfig[]> {
  // 获取当前保存的token
  const accessToken = localStorage.getItem('accessToken');
  
  const response = await httpClient.sendRequest({
    url: 'config/system_setting',
    method: 'GET',
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
  });
  
  return response.data;
}
